import React from 'react';
import BottomNavbar from '../userNavbar/BottomNavbar';

const UserNavbar = () => {
    return (
        <>

          {/* Bottom Navbar – visible on all screens, fixed */}
          <div className="sticky inset-0 z-40">
            <BottomNavbar />
          </div>

        </>
    );
};

export default UserNavbar;